import { useEffect } from "react";

const stableDeps: readonly unknown[] = [];

export default function useEscapeKey(action: (e: KeyboardEvent) => void, deps: readonly unknown[] = stableDeps) {
  useEffect(() => {
    const escape = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        action(e);
      }
    };
    document.addEventListener("keydown", escape);

    return () => {
      document.removeEventListener("keydown", escape);
    };
  }, deps);
}
